// Labels every team profile shares, Bulgarian: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Лични данни',
    rows: {
      name: 'Име',
      position: 'Длъжност',
      birthdate: 'Дата на раждане',
      nationality: 'Гражданство',
      maritalStatus: 'Семейно положение',
      location: 'Местоположение',
      languages: 'Езици',
      programmingLanguages: 'Езици за програмиране',
      certifications: 'Сертификати',
      publications: 'Публикации',
      links: 'Уебсайт'
    }
  },
  education: {
    title: 'Образование'
  },
  skills: {
    title: 'Професионални умения'
  },
  experience: {
    title: 'Проекти и дейности',
    techLabel: 'Технологии'
  },
  downloads: {
    title: 'Изтегляне на профила',
    deLabel: 'Изтегляне на профила на немски',
    deDescription: 'PDF на немски език',
    enLabel: 'Изтегляне на автобиографията на английски',
    enDescription: 'PDF на английски език'
  },
  cta: {
    title: 'Контакт',
    button: 'Свържете се с нас'
  },
  pdf: {
    title: 'Профил',
    personalSection: 'Лични данни',
    educationSection: 'Образование',
    experienceSection: 'Проекти и дейности',
    skillsLabel: 'Умения'
  }
};
